const settings = {
    passages: {
        // start: "game.changeDay"
        // start: "start.wife"
        start: "start.startPassage"
    },
    project: {
        name: "Lermose: McNiel Story",
        debug: false // if debug => you will see initialized variables after reload page
    },
    say: {
        defaultColor: "black",
        fontSize: "18px"
    },
    name: {
        defaultColor: "black",
        fontSize: "16px"
    }
}

export default settings;